import { DOMSerializer } from 'prosemirror-model'
import { schema } from 'prose-core'
import { AnalysisWorkerWrapper, Paper, Result } from '@almanaclabs/yoastseo/dist/index.js'
import { useState } from 'react'
import { Node } from 'prosemirror-model'
import { reportError } from 'utils/error'
import { findNodeByType } from 'common/Prose/utils/findNodeByType'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'

const blacklistedResults = ['metaDescriptionLength', 'titleWidth', 'textImages', 'internalLinks', 'titleWidth']

const filterResults = (results: Result) => {
  return {
    ...results,
    seo: {
      ...results.seo,
      '': {
        ...results.seo[''],
        results: results.seo[''].results.filter((r) => !blacklistedResults.includes(r._identifier)),
      },
    },
  }
}

export const useSEOAnalysis = () => {
  const [error, setError] = useState<boolean>(false)
  const view = useEditorView()
  const [results, setResults] = useState<Result | null>(null)
  const [keyword, setKeyword] = useState('')

  const analyze = async () => {
    setError(false)

    const aiNode = findNodeByType(view.state.doc, schema.nodes.ai_suggestion)
    let aiContent
    if (aiNode) {
      aiContent = Node.fromJSON(schema, { type: 'doc', content: JSON.parse(aiNode.attrs.contentData) })
    }
    const div = document.createElement('div')
    const html = DOMSerializer.fromSchema(schema).serializeFragment(
      aiContent ? aiContent.content : view.state.doc.content,
    )
    div.appendChild(html)

    const worker = new Worker(new URL('workers/yoastseoWorker.js', import.meta.url), {
      type: 'module',
    })

    // Create an AnalysisWorkerWrapper
    const analysisWorker = new AnalysisWorkerWrapper(worker)
    analysisWorker
      .initialize({
        locale: 'en_US',
        contentAnalysisActive: true,
        keywordAnalysisActive: true,
        logLevel: 'ERROR',
      })
      .then(() => {
        // The worker has been configured, we can now analyze a Paper.
        const paper = new Paper(div.innerHTML, {
          keyword,
        })

        return analysisWorker.analyze(paper)
      })
      .then((results) => {
        const filteredResults = filterResults(
          keyword.length
            ? results.result
            : {
                ...results.result,
                seo: {
                  '': {
                    ...results.result.seo[''],
                    results: results.result.seo[''].results.filter((r) => !r.text.includes('Keyphrase')),
                  },
                },
              },
        )

        setResults(filteredResults)
      })
      .catch((error) => {
        setError(true)

        // this will properly report the error to Sentry when it's not an instance of Error
        if (!(error instanceof Error)) {
          error = new Error(`Non-Error thrown: ${JSON.stringify(error)}`)
        }

        reportError(error, { severity: 'error' })
        setResults(null)
      })
  }

  return {
    error,
    results,
    keyword,
    setKeyword,
    analyze,
  }
}
